import styled from '@emotion/styled';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const SettingWrapper = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  padding: 20px 40px;
  /* padding: 47.65px 40px 46.35px; */
  margin-top: 10px;
  &:first-of-type {
    margin-top: 0;
  }
  & > strong {
    position: relative;
    display: block;
    width: 240px;
    height: 24px;
    font-size: 14px;
    line-height: 23px;
  }
`;

export const SettingBox = styled.div`
  position: relative;
  flex: 1;
  margin-left: 32px;
  padding-top: 10px;
  padding-bottom: 10px;

  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -32px;
    background: #e0e0e0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;

export const SettingBoxList = styled.div`
  margin: 40px 30px;
`;

export const SettingBoxListTitle = styled.div`
  font-weight: 700;
  font-size: 12px;
`;
export const SettingBoxListValue = styled.div`
  margin-top: 10px;
`;

export const SettingList = styled.ul`
  position: relative;
  margin-bottom: 30px;

  & > li {
    display: flex;
    white-space: nowrap;
    align-items: center;
    margin-top: 28px;
    font-size: 16px;
    color: #333;
    &:first-of-type {
      margin-top: 0;
    }
  }
  & .guide-text {
    margin-top: 10px;
    font-weight: 400;
    font-size: 12px;
    color: #fa8282;
  }
  & .selectbox-text {
    margin-left: 5px;
    color: #484848;
  }
`;

export const InputList = styled.ul`
  position: relative;
  display: flex;
  align-items: center;

  & li {
    margin-right: 50px;
  }
  & .sub-title {
    width: 150px;
  }
  & .send-off {
    margin-left: 5px;
  }
`;

export const SwButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 53px;
  & button {
    margin-top: 0;
  }
`;

export const SelectBox = styled.div`
  min-width: 84px;
  font-size: 14px;
  x & div {
    border-radius: 4px;
  }
  & ol {
    & li {
      padding: 0 16px;
      justify-content: left;
    }
  }
`;

export const Row = styled.div`
  & + & {
    margin-top: 8px;
  }
`;

export const FlexBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;

  span {
    &.title {
      width: 75px;
    }

    &.l-title {
      margin-right: 28px;
    }

    &.suffix {
      margin-left: 8px;
    }
  }

  & + & {
    margin-left: 45px;
  }
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const InputBox = styled.div`
  width: 90px;
`;

export const ThresholdDisplay = styled.div`
  width: 35px;
  height: 20px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #555;
  color: #252525;
  background-color: #dedede;
  user-select: none;
`;

export const Description = styled.div`
  margin-left: 24px;
  font-size: 9px;
  color: #b6b6b6;
`;

export const SliderWrapper = styled.div`
  width: 200px;
  margin-left: 12px;
`;

export const ElementBox = styled.div`
  position: relative;
  border: 1px solid #e0e0e0;
  padding: 20px 20px 30px 28px;

  &.active {
    & .title {
      background-color: #00bf00;
      &:after {
        background-color: #7fe200;
      }
    }

    &:after {
      background-color: #2de100;
    }
  }

  &:after {
    content: '';
    position: absolute;
    width: 5px;
    top: -1px;
    left: -1px;
    bottom: -1px;
    background-color: #999;
  }

  & + & {
    margin-top: 16px;
  }
`;

export const ElementTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
`;

export const ElementRow = styled.div`
  display: flex;
  height: 50px;
  margin-top: 6px;
  align-items: center;
`;

export const ElementValue = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0px 24px;

  & > .input-value {
    width: 100%;
  }
`;

export const ElementMetatag = styled.div`
  position: relative;
  width: 210px;
  height: 50px;
  line-height: 50px;
  padding: 0 20px 0 26px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 700;
  color: white;
  background-color: #999;

  &:after {
    content: '';
    position: absolute;
    width: 4px;
    top: 0px;
    left: 0px;
    bottom: 0px;
    background-color: #ccc;
  }

  @media (max-width: 1600px) {
    width: 110px;
  }
`;
